import { render, staticRenderFns } from "./goodspackage_detail_report.vue?vue&type=template&id=5fc9d6f2&scoped=true"
import script from "./goodspackage_detail_report.vue?vue&type=script&lang=js"
export * from "./goodspackage_detail_report.vue?vue&type=script&lang=js"
import style0 from "./goodspackage_detail_report.vue?vue&type=style&index=0&id=5fc9d6f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc9d6f2",
  null
  
)

export default component.exports